export default {
    batchPoints: {
        method: 'PUT',
        url: '/manage-system/user/point/send',
        name: '修改会员积分,同步更新到积分记录表',
    },
    memberList: {
        method: 'POST',
        url: '/manage-system/user/page',
        name: '分页查询用户列表',
    },
    recordList: {
        method: 'POST',
        url: '/manage-system/user/point/page',
        name: '会员积分列表',
    },
    block: {
        method: 'PUT',
        url: '/manage-system/user/block/{userId}',
        name: '拉黑',
    },
    unblock: {
        method: 'PUT',
        url: '/manage-system/user/unblock/{userId}',
        name: '取消拉黑',
    },
    submitRefund: {
        method: 'POST',
        url: '/admin/member/submitRefund',
        name: '发起退款',
    },
    perfectInfo: {
        method: 'POST',
        url: '/admin/member/toPerfectInfo',
        name: '信息完善(宝宝认证)',
    },
    memberDetail: {
        method: 'GET',
        url: '/admin/member/{id}',
        name: '会员详情',
    },
    addGradeConfig: {
        method: 'POST',
        url: '/admin/gradeConfig',
        name: '新增会员等级',
    },
    updateGradeConfig: {
        method: 'PUT',
        url: '/admin/gradeConfig',
        name: '编辑会员等级',
    },
    gradeConfigList: {
        method: 'POST',
        url: '/admin/gradeConfig/list',
        name: '会员等级列表',
    },
    allGradeList: {
        method: 'GET',
        url: '/manage-system/user/allGradeList',
        name: '会员等级下拉列表',
    },
    repairOrder: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/userTicketGrant',
        name: '补开卡',
    },
    reserve: {
        method: 'POST',
        url: '/manage-system/userTicket/reserve/userTicketReserve',
        name: '补预约',
    },
    queryUserTicketSuppleReservePage: {
        method: 'POST',
        url: '/manage-system/userTicket/reserve/queryUserTicketSuppleReservePage',
        name: '补预约管理分页',
    },
    getPeriodByDate: {
        method: 'POST',
        url: '/manage-system/reserve/period/getPeriodByDate',
        name: '获取预约库存日期段的场次信息',
    },
    userGrade: {
        method: 'GET',
        url: '/admin/member/userGrade',
        name: '会员等级列表',
    },
    getUserTicketDetails: {
        method: "GET",
        url: "/manage-system/userTicket/reserve/getUserTicketReserveDetailByDate/{userTicketNo}",
        name: '获取用户票券预约详情',
    },
    reservePeriod: {
        method: 'GET',
        url: '/admin/member/reserve/{ticketId}/{shopId}/{date}',
        name: '补预约场次列表',
    },
    userTicketPrivilegeList: {
        method: 'GET',
        url: '/admin/member/userTicketPrivilegeList/{userTicketId}',
        name: '获得用户票权限列表',
    },
    // templateUrl: {
    //     method: 'GET',
    //     url: '/manage-system/userTicket/operate/templateUrl',
    //     name: '补开卡模板地址',
    // },
    templateUrl: {
        method: 'GET',
        url: '/manage-system/userTicket/operate/excelTemplate',
        name: '补开卡模板地址',
    },
    importRecord: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/importRecord',
        name: '导入记录列表',
    },
    batchRepairOrder: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/batch/userTicketGrant',
        name: '批量补开卡excel导入',
    },
    getStoredValueConsume: {
        method: 'POST',
        url: '/manage-system/user/balance/page',
        name: '会员信息详情-储值余额消费记录',
    },
    importFailRecord: {
        method: 'POST',
        url: '/manage-system/userTicket/operate/importFailRecord',
        name: '导入失败记录列表',
    },
    manualRefund: {
        method: 'DELETE',
        url: '/manage-system/user/balance/all/{userId}',
        name: '用户储值修改',
    },
    repairTicketList: {
        method: 'POST',
        url: '/manage-system/userTicket/query/queryUserTicketGoodsGrantPage',
        name: '补开卡管理分页',
    },
    getTicketGiveInfoVoByTicketId: {
        method: 'GET',
        url: '/manage-system/give/admin/getTicketGiveInfoVoByTicketId/{ticketId}',
        name: "根据主票id获取赠品"
    },
    reserveTime: {
        method: 'GET',
        url: '/admin/member/reserveTime/{userTicketPrivilegeId}/{reserveDate}',
        name: '获取票券预约相关次数信息',
    },
    viewMemberInfo: {
        method: 'GET',
        url: '/manage-system/user/{userId}',
        name: '查询用户详情',
    },
    batchModifyAppUserStoredValue: {
        method: 'PUT',
        url: '/manage-system/user/balance/send',
        name: '批量修改用户储值',
    },

    operateMemberLogList: {
        method: 'POST',
        url: '/manage-system/user/operate/log',
        name: '大后台操作会员日志列表',
    },
    getOrderDate: {
        method: 'GET',
        url: '/manage-system/userTicket/reserve/getTicketSuitShopReserveStockConfigList/{ticketId}',
        name: '获取票券适用门店预约库存配置列表',
    },
    findAllLabel: {
        method: 'POST',
        url: '/manage-system/user/findAllLabel',
        name: '查询所有用户标签',
    },
    addUserLabel: {
        method: 'POST',
        url: '/manage-system/user/addUserLabel',
        name: '设置用户标签',
    },
    userCouponList: {
        method: 'POST',
        url: '/manage-system/userCoupon/page-list',
        name: '分页查询用户优惠券列表',
    },
    userCouponExport: {
        method: 'POST',
        url: '/manage-system/userCoupon/export',
        name: '导出用户优惠券',
    },

}